<template>
  <v-container class="my-7">
    <grid-container
      :layout="layout"
      gap="12px"
      gap-md="24px"
      cols="1fr 1fr"
      cols-sm="repeat(6, 1fr)"
      cols-md="repeat(12, 1fr)"
    >
      <template #banner-top>
        <banner type="top" />
      </template>
      <template #magazines>
        <Magazines />
      </template>
      <template #featured> <Featured /> </template>
      <template #most-read>
        <MostRead />

        <banner-video v-if="!sm" type="right-b" />
      </template>
      <template #latest-news> <LatestNews /> </template>
      <template #banner-right-a> <banner-video /> </template>
      <template #banner-right-b> <banner-video type="right-b" /> </template>
      <template #banner-center-two>
        <banner type="center-2" />
      </template>
      <template #banner-center-one-a>
        <banner type="center-1-a" />
      </template>
      <template #banner-center-one-b>
        <banner type="center-1-b" />
      </template>

      <template #banner-center-tree-a>
        <banner type="center-3-a" />
      </template>

      <template #categories>
        <categories />
      </template>
      <template #videos>
        <Videos />
      </template>
      <template #banner-bottom-a>
        <banner type="bottom-a" />
      </template>
      <template #banner-bottom-b>
        <banner type="bottom-b" />
      </template>
    </grid-container>
  </v-container>
</template>

<script>
import Banner from "@/components/cards/Banner.vue";
import BannerVideo from "@/components/cards/BannerVideo.vue";
import Magazines from "./Magazines.vue";
import Featured from "./Featured.vue";
import LatestNews from "./LatestNews.vue";
import Videos from "./Videos.vue";
import Categories from "./Categories.vue";
import MostRead from "@/components/widgets/MostRead.vue";

const f = (n, str) => Array(n).fill(str);

const layout = {
  xs: [
    ["banner-top", "banner-top"],
    ["featured", "featured"],
    ["banner-right-a", "banner-right-a"],
    ["banner-center-two", "banner-center-two"],
    ["banner-center-one-a", "banner-center-one-a"],
    ["latest-news", "latest-news"],
    ["banner-center-tree-a", "banner-center-tree-a"],
    ["categories", "categories"],
    ["most-read", "most-read"],
    ["videos", "videos"],
    ["magazines", "magazines"],
    ["banner-bottom-a", "banner-bottom-a"],
    ["banner-bottom-b", "banner-bottom-b"],
  ],
  sm: [
    [...f(6, "banner-top")],
    [...f(6, "featured")],
    [...f(3, "banner-right-a"), ...f(3, "banner-right-b")],
    [...f(6, "latest-news")],
    [...f(6, "banner-center-two")],
    [...f(3, "banner-center-one-a"), ...f(3, "banner-center-one-b")],
    [...f(6, "categories")],
    [...f(6, "videos")],
    [...f(6, "most-read")],
    [...f(6, "magazines")],
    [...f(6, "banner-bottom-a")],
    [...f(6, "banner-bottom-b")],
  ],
  desktop: [
    [...f(12, "banner-top")],
    [...f(8, "featured"), ...f(4, "banner-right-a")],
    [...f(8, "featured"), ...f(4, "most-read")],
    [...f(8, "featured"), ...f(4, "most-read")],
    [...f(8, "latest-news"), ...f(4, "most-read")],
    [...f(8, "latest-news"), ...f(4, "most-read")],
    [...f(8, "latest-news"), ...f(4, "most-read")],
    [...f(12, "banner-center-two")],
    [...f(6, "banner-center-one-a"), ...f(6, "banner-center-one-b")],
    [...f(12, "categories")],
    [...f(12, "videos")],
    [...f(12, "magazines")],
    [...f(6, "banner-bottom-a"), ...f(6, "banner-bottom-b")],
  ],
};

export default {
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    layout() {
      if (this.xs) return layout.xs;
      else if (this.sm) return layout.sm;
      else return layout.desktop;
    },
  },
  components: {
    Banner,
    BannerVideo,
    Magazines,
    Featured,
    LatestNews,
    Videos,
    MostRead,
    Categories,
  },
};
</script>
